import { styled } from "@mui/material"
import { palette } from "view/themes/palette"

export const Wrapper = styled("div")(() => ({
  width: 600,
}))

export const Title = styled("div")(() => ({
  fontFamily: "Inter",
  fontWeight: 600,
  fontSize: 16,
  lineHeight: "20px",
  marginBottom: 32,
}))

export const FormRow = styled("div")(() => ({
  marginBottom: 32,
}))

export const Buttons = styled("div")(() => ({
  display: "flex",
  gap: 12,
}))

export const ReqHeaderRow = styled("div")(() => ({
  display: "grid",
  gridTemplateColumns: "210px 1fr 21px",
  alignItems: "center",
  gap: 9,
  marginBottom: 16,

  svg: {
    cursor: "pointer",
  },

  span: {
    fontSize: 12,
  },
}))

export const CheckboxGroupList = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
}))

export const CheckboxGroupLabel = styled("div")(() => ({
  fontSize: 14,
  fontFamily: "Inter",
  fontWeight: 600,
  marginBottom: 12,
}))

export const SecretKey = styled("div")(() => ({
  fontSize: 14,
  marginBottom: 12,
}))

export const HeadersError = styled("div")(() => ({
  marginBottom: "16px",
  fontSize: 13,
  color: palette.error500,
}))

export const EventsError = styled("div")(() => ({
  marginTop: "16px",
  fontSize: 13,
  color: palette.error500,
}))
